import React, { Component }  from 'react'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import PanoramaFishEye from 'material-ui/svg-icons/image/panorama-fish-eye'

export default class StatusIcon extends Component{
	render(){
		let { props } = this
		return(
			!props.status?
			<div></div>
			:
			<div
				style={{
					marginLeft: "10px"
				}}
			>
				{props.status=="0closed"?
					<CheckCircle color="rgb(0, 188, 212)"/>
					:
						props.status=="3pending"?
					<PanoramaFishEye color="rgb(200, 200, 200)"/>
						:
							props.status=="1urgent"?
							<i className="material-icons" style={{color: "#fd9a41"}}>brightness_1</i>
							:<PanoramaFishEye />
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/manager/tenants/StatusIcon.js